(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/account-selector-container.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/account-selector-container.js');

'use strict';

const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  setActiveAccount
} = svs.gamePackage.redux.accountSlice.actions;
const {
  AccountSelector
} = svs.numbergames.accountSelectorReact;
const {
  useCallback
} = React;
const AccountSelectorContainer = () => {
  const dispatch = useDispatch();
  const packageDoesntContainTicketGames = useSelector(_ref => {
    let {
      tickets
    } = _ref;
    return !tickets.games.length;
  });
  const handleChangeAccount = useCallback(account => {
    dispatch(setActiveAccount(account));
  }, [dispatch]);
  if (packageDoesntContainTicketGames && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    return React.createElement("div", {
      className: "margin-top-2 padding-h-1"
    }, React.createElement("div", {
      className: "account-selector-container"
    }, React.createElement(AccountSelector, {
      onChange: handleChangeAccount
    })));
  }
  return null;
};
svs.gamePackage.components.AccountSelectorContainer = AccountSelectorContainer;

 })(window);